import { jsx as b } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import a from "clsx";
import e from "./box.module.css.js";
const j = ["none", "xs", "sm", "md", "lg", "xl"], h = p(function({ as: n, className: m, padding: s, style: c, variant: l = "blue", ...i }, f) {
  const x = n || "div", r = { ...c };
  return Object.entries(typeof s == "object" ? s : { xs: s ?? null }).forEach(([u, t]) => {
    t !== null && (r[`--${u}-pad`] = `${t}`.split(" ").map(
      (o) => Number.isInteger(Number(o)) ? `${o}px` : j.includes(o) ? `var(--pad-size-${o})` : o
    ).join(" "));
  }), /* @__PURE__ */ b(
    x,
    {
      className: a(m, e.box, e[l]),
      ref: f,
      style: r,
      ...i
    }
  );
});
export {
  h as Box
};
//# sourceMappingURL=box.js.map
